import React, { useEffect } from 'react';
import { Spinner, ContextMenu } from '@blueprintjs/core';
import { observer } from 'mobx-react-lite'

// ws
import { socketConnection } from 'tools/socketManager';
import { ON_NAV_OBJECT_CHANGED } from 'constants/socketManager';

// store
import { mobileObjectsListStore } from 'stores/objectsObserverListStore'
import SocketStore from 'stores/socketStore'

// global components
import VirtualList from 'components/VirtualList';

// local components
import Breadcrumbs from '../components/Breadcrumbs';
import MobileObjectContextMenu from './MobileObjectContextMenu';

// styles
import { Styled } from '../LeftPanel.styled'

const MobileObjectsList = observer(() => {
  const {
    isLoading,
    isErrorred,
    list,
    dataLength,
    breadCrumbs,
    loadStep,
    searchedObjectIndex,
    loadMObjects,
    loadMoreRows,
    showObject,
    selectedObjectIds,
    setSelectedObjectIds,
    handleRowDblClick,
    handleBreadcrumbClick,
    changeListItem
  } = mobileObjectsListStore

  const updatedItem = SocketStore.getChannelData(ON_NAV_OBJECT_CHANGED, 'MobileObject');

  const handleContextMenu = (event, objectId, type, objectName) => {
    event.preventDefault();
    ContextMenu.show(MobileObjectContextMenu(objectId, type, showObject, objectName), {
      left: event.clientX,
      top: event.clientY,
    });
  };

  useEffect(() => {
    loadMObjects();
  }, [loadMObjects, loadStep]);

  useEffect(() => {
    if(updatedItem) {
      changeListItem(updatedItem)
    }
  }, [updatedItem, changeListItem]);

  useEffect(() => {
    if (!socketConnection) return

    SocketStore.addSocketChannel(ON_NAV_OBJECT_CHANGED, 'MobileObject', '')

    return () => SocketStore.removeSocketChannel(ON_NAV_OBJECT_CHANGED, 'MobileObject', '')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socketConnection]);

  return (
    <>
      <Breadcrumbs
        breadcrumbs={breadCrumbs}
        onBreadcrumbClick={handleBreadcrumbClick}
      />
      <Styled.ListContainer>
        {isLoading ? (
          <Spinner />
        ) : isErrorred ? (
          <p>Произошла ошибка, попробуйте перезагрузить страницу</p>
        ) : (
          <VirtualList
            loadMoreRows={loadMoreRows}
            list={list}
            needSelectObj={false}
            loadStep={loadStep}
            rowCount={dataLength}
            onRowDblClick={handleRowDblClick}
            onRigthClick={handleContextMenu}
            selectedObjectIds={selectedObjectIds}
            setSelectedObjectIds={setSelectedObjectIds}
            searchedObjectIndex={searchedObjectIndex}
          />
        )}
      </Styled.ListContainer>
    </>
  );
});

export default MobileObjectsList;
